import * as React from 'react';
const SvgNotifyOff = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" {...props}>
        <path
            d="M3.402 5.557a4.66 4.66 0 01.12-.618L.792 2.21A1 1 0 112.208.797l13 13a1 1 0 01-1.414 1.414l-1.207-1.207H10.45a2.5 2.5 0 01-4.9 0H2.32c-.498 0-.95-.294-1.152-.75a1.145 1.145 0 01.272-1.306l.353-.325a3.553 3.553 0 001.118-2.17l.49-3.895zM13.026 8.976l-.43-3.419A4.635 4.635 0 009 1.612v-.61a1 1 0 10-2 0v.609a4.615 4.615 0 00-1.335.522l7.103 7.102.258-.259z"
            fill="currentColor"
        />
    </svg>
);
export default SvgNotifyOff;
